<template>
  <div class="layout-history-list">
    <div class="history-list-box kye-scrollbar" v-show="list.length">
      <div class="history-item" v-for="item in list" :key="item.id" :class="{'history-item-v2': item.iconUrlV2}">
        <img class="history-item-left" :src="item.iconUrlV2 || item.iconUrlNew" @click="handleClick(item)"/>
        <div class="history-item-right">
          <div class="title-box">
            <div class="read-type" :class="{'read-type-unread': item.hasRead === 0}"><span class="read-type-text">{{item.hasRead === 0 ? '未读':'已读'}}</span></div>
            <div class="title">{{item.name}}</div>
          </div>
          <div class="time-box">
            {{item.startTime | minute}}
          </div>
        </div>
      </div>
    </div>
    <div class="empty-box" v-show="!list.length">
      <img src="../images/no-history.svg" alt="">
      <div class="empty-text">暂无历史记录</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      handleClick (item) {
        this.$emit('click', item, this.list)
      }
    }
  }
</script>

<style lang="scss" scoped>
.layout-history-list {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 8px;

  .history-item {
    height: 76px;
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 10px 16px;
    cursor: pointer;
    .history-item-left {
      width: 240px;
      height: 56px;
      flex-shrink: 0;
      display: block;
      object-fit: contain;
      object-position: center;
      // border: 1px solid #EFEEF0; // theme
      border-radius: 8px;
      background: #EDE7FF;
      border: 1px solid rgba(239, 238, 240, 1);
    }
    &.history-item-v2 {
      .history-item-left {
        object-fit: cover;
      }
    }
    .history-item-right {
      flex: 1;
      padding-left: 10px;
      display: flex;
      min-width: 0;
      flex-direction: column;
      justify-content: center;
    }
    .read-type {
      color: rgba(136, 142, 166, 0.8);
      border: 0.5px solid rgba(221, 226, 233, 1);
      background: rgba(247, 248, 250, 1);;
      height: 20px;
      line-height: 20px;
      width: 38px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border-radius: 8px;
      margin-right: 6px;
      .read-type-text {
        font-size: 12px;
        line-height: 12px;
        color: #41464F;
        white-space: nowrap;
      }
      &-unread {
        border: 0.5px solid #FFDBCF;
        background: rgba(255, 238, 233, 1);
        .read-type-text {
          color: #E55454; // theme
        }
      }
    }
    .title-box {
      display: flex;
      align-items: center;
      .title {
        height: 16px;
        line-height: 16px;
        font-weight: 600;
        color: #453C5A;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      margin-bottom: 8px;
    }
    .time-box {
      color: #A09EBF; // theme
      font-size: 12px;
      line-height: 14px;
      height: 14px;
    }
    &:hover {
      background: #F1F1F5;
      .title {
        color: var(--g-color-primary);
      }
    }
  }
  .history-list-box {
    width: 100%;
  }
  .empty-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    img {
      display: block;
      width: 310px;
      height: 200px;
    }
    .empty-text {
      color: #999999;
      font-size: 12px;
      margin-bottom: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/drawer/history-banner-list.vue